import { unref } from 'vue';
import { getAlertColorForeground } from '@@/utils/CommonUtils';
import { chartColors, getBorderRadius } from '@@/utils/ChartUtils';
import { useMetaStore } from '@@/stores/Meta';

/**
 * @todo Write unit tests for exported functions,
 */
export const hasNoSnow = (day = {}) => {
  const metaStore = useMetaStore();
  const powderAlert = metaStore.getPowderAlert(day.alerts);
  return !powderAlert || day?.precip_snow_max === 0;
};

export const createChartDataSets = (params = {}) => {
  const {
    includeNotAvailable = false,
    theme,
  } = params;

  const dataSetTemplate = () => ({
    backgroundColor: chartColors.textDarkest(unref(theme)),
    borderRadius: 0,
    data: [],
    datalabels: {
      color: chartColors.textDarkest(unref(theme)),
    },
    minBarLength: 1,
  });

  const dataSets = {
    none: dataSetTemplate(),
  };

  if (includeNotAvailable) {
    dataSets.notAvailable = dataSetTemplate();
  }

  return dataSets;
};

export const updateChartDataSets = (params = {}) => {
  const {
    dataSets = {},
    forecastPeriod = {},
    snowValue = null,
  } = params;
  const metaStore = useMetaStore();

  let dataSet = null;
  let snow = snowValue;

  if (dataSets.notAvailable && (snow === null || snow === undefined)) {
    dataSet = dataSets.notAvailable;
    snow = '';
  }
  else if (hasNoSnow(forecastPeriod)) {
    dataSet = dataSets.none;
  }
  else {
    const barColor = getAlertColorForeground(metaStore.getPowderAlert(forecastPeriod.alerts));

    if (!dataSets[barColor]) {
      dataSets[barColor] = {
        backgroundColor: barColor,
        borderRadius: getBorderRadius(),
        data: [...dataSets.none.data].fill(undefined),
        datalabels: {
          color: barColor,
        },
        minBarLength: 3,
      };
    }

    dataSet = dataSets[barColor];
  }

  Object.values(dataSets).forEach((ds) => ds.data.push(ds === dataSet ? snow : undefined));
};
